import { render, staticRenderFns } from "./GetStartedForm.vue?vue&type=template&id=ee38ec40&lang=pug&"
import script from "./GetStartedForm.vue?vue&type=script&lang=js&"
export * from "./GetStartedForm.vue?vue&type=script&lang=js&"
import style0 from "./GetStartedForm.vue?vue&type=style&index=0&id=ee38ec40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports